// extracted by mini-css-extract-plugin
export default {"root":"ProductBadge_root__2c_2r","inline":"ProductBadge_inline__32s5E","text":"ProductBadge_text__33Eo5"};